module.exports = __webpack_public_path__ + "static/media/decodificador_p.9e573ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/decodificador_p.png
// module id = 1164
// module chunks = 0